/* eslint-disable */
import { auth } from "@/plugins/auth/firebase.js";
import * as firebase from "firebase";
import * as functions from "./functions.js";
import router from "@/router.js";
import axios from "axios";
import * as vars from "@/vars.json";
import store from "@/store";
import moment from "moment";

const httpAxios = axios.create({
  params: {}
});
const rejectPage = "404 Error";
var host = window.location.protocol + "//" + window.location.host;

export const payment = {
  namespaced: true,
  state: {
    currencies: {},
    restrictions: {},
    plan_reactivate: {
      data: {
        cost: 0,
        heading: "Plan Reactivate",
        icon: "mdi-home",
        position: 0,
        id_plan: "Plan_Reactivate",
        restrictions: {
          collaborators: 1,
          freeVirtualShopDays: 0,
          salePoints: 1,
          virtualShops: 1,
          currentAmountSale: 0,
          maxAmountSale: 100
        },
        limitWarning: 90,
        text: "Si estas emprendiendo",
        title: "REACTIVATE",
        type: "month"
      }
    }
  },
  mutations: {
    SET_RESTRICTIONS: (state, data) => {
      state.restrictions = data;
    },
    SET_CURRENCIES: (state, data) => {
      state.currencies = data;
    }
  },
  actions: {
    setMainCard({ state, rootState }, data) {
      return new Promise((resolve, reject) => {
        let addDefaultCard_customer = {
          franchise: data.card.name,
          token: data.token.id,
          mask: data.card.mask,
          customer_id: data.customerId
        };

        addDefaultCard_customer = functions.encrypt(addDefaultCard_customer);

        httpAxios
          .post(vars.url + "/addDefaultCard", addDefaultCard_customer)
          .then(response => {
            response.data = functions.decrypt(response.data);
            if (response.data.status) {
              const uid = rootState.users.user.uid;
              firebase
                .database()
                .ref(`users/${uid}/payment`)
                .update({
                  card: data.card,
                  token: data.token,
                  person: data.person
                })
                .then(res => {
                  // commit('SET_LOADING', false)
                  resolve(true);
                })
                .catch(err => {
                  // commit('SET_LOADING', false)
                  // router.push(rejectPage)
                  reject(err);
                });
            } else {
              resolve(false);
            }
          })
          .catch(error => {
            // router.push(rejectPage)
            reject(error);
          });
      });
    },
    getCardData({ state, rootState }) {
      return new Promise((resolve, reject) => {
        const uid = rootState.users.user.uid;
        firebase
          .database()
          .ref(`users/${uid}/payment`)
          .once(
            "value",
            snapshot => {
              const res = snapshot.val();
              resolve(res);
            },
            error => {
              // router.push(rejectPage)
              reject(error);
            }
          );
      });
    },
    getVitualShopUser({ state, rootState }, uidShop) {
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`virtualshop/`)
          .orderByChild("dataShop/uid")
          .equalTo(rootState.users.user.uid)
          .once(
            "value",
            snapshot => {
              const res = snapshot.val();
              let arr = [];
              if (res) {
                arr = Object.keys(res).map(item => {
                  return { id: item, data: res[item] };
                });
              }
              resolve(arr);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    getSubscriptionData({ state, rootState, dispatch }, data) {
      return new Promise(async (resolve, reject) => {
        const shopsList = data.shops;
        const collaboratorsList = data.collaborators || [];
        let uid;
        // console.log(data)
        if (rootState.users.user.adminUid) {
          uid = rootState.users.user.adminUid;
        } else {
          uid = rootState.users.user.uid;
        }
        // console.log(data)
        if (data.currentAmountSale) {
          firebase
            .database()
            .ref(`users/${uid}/payment/subscription/restrictions/`)
            .update({ currentAmountSale: +data.currentAmountSale });

          if (
            +data.currentAmountSale >=
            state.plan_reactivate.data.restrictions.maxAmountSale
          ) {
            await firebase
              .database()
              .ref(`users/${uid}/payment/subscription/status`)
              .set({ val: "inactive" });
            for (let i = 0; i < shopsList.length; i++) {
              firebase
                .database()
                .ref(`users/${uid}/shops/${shopsList[i].id}/status`)
                .set({ val: "inactive" });
            }
            for (let i = 0; i < collaboratorsList.length; i++) {
              firebase
                .database()
                .ref(
                  `users/${uid}/collaborators/${collaboratorsList[i].id}/status`
                )
                .set({ val: "inactive" });
            }
            dispatch("users/updateVirtualShopsStatus", null, { root: true });
          }
          resolve();
        } else {
          const dataRestrictions = {
            uid: uid
          };
          httpAxios
            .post(vars.url + "/getUserRestrictions", dataRestrictions)
            .then(resRestrictions => {
              if (resRestrictions && resRestrictions.data !== "") {
                let banContinue = true;
                if (resRestrictions.data.dateFrom) {
                  let nowTime = new Date().getTime();
                  let initTime = parseInt(resRestrictions.data.dateFrom);
                  let endTime = parseInt(resRestrictions.data.dateUntil);
                  if (nowTime >= initTime && nowTime <= endTime) {
                    banContinue = true;
                  } else {
                    banContinue = false;
                  }
                  if (resRestrictions.data.active && banContinue) {
                    for (let i = 0; i < shopsList.length; i++) {
                      if (
                        i < resRestrictions.data.salePoints &&
                        i < shopsList.length
                      ) {
                        firebase
                          .database()
                          .ref(`users/${uid}/shops/${shopsList[i].id}/status`)
                          .set({ val: "active" });
                      } else {
                        firebase
                          .database()
                          .ref(`users/${uid}/shops/${shopsList[i].id}/status`)
                          .set({ val: "inactive" });
                      }
                    }
                    for (let i = 0; i < collaboratorsList.length; i++) {
                      if (
                        i < resRestrictions.data.collaborators &&
                        i < collaboratorsList.length
                      ) {
                        firebase
                          .database()
                          .ref(
                            `users/${uid}/collaborators/${collaboratorsList[i].id}/status`
                          )
                          .set({ val: "active" });
                      } else {
                        firebase
                          .database()
                          .ref(
                            `users/${uid}/collaborators/${collaboratorsList[i].id}/status`
                          )
                          .set({ val: "inactive" });
                      }
                    }

                    let sendRes = {
                      data: {
                        amount: "0",
                        createdAt: moment(resRestrictions.data.dateFrom).format(
                          "YYYY-MM-DD"
                        ),
                        currency: "cop",
                        description: "RESTRCCIONES INTERNAS",
                        idClient: "PERSONALIZADO",
                        interval: "NINGUNO",
                        interval_count: "0",
                        name: "PERSONALIZADO",
                        trialDays: resRestrictions.data.trialDays
                      },
                      id: "",
                      restrictions: resRestrictions.data,
                      status: {
                        val: "active"
                      }
                    };
                    resolve(sendRes);
                  } else {
                    for (let i = 0; i < shopsList.length; i++) {
                      firebase
                        .database()
                        .ref(`users/${uid}/shops/${shopsList[i].id}/status`)
                        .set({ val: "inactive" });
                    }
                    for (let i = 0; i < collaboratorsList.length; i++) {
                      firebase
                        .database()
                        .ref(
                          `users/${uid}/collaborators/${collaboratorsList[i].id}/status`
                        )
                        .set({ val: "inactive" });
                    }
                    let sendRes = {
                      data: {
                        amount: "0",
                        createdAt: moment(resRestrictions.data.dateFrom).format(
                          "YYYY-MM-DD"
                        ),
                        currency: "cop",
                        description: "RESTRCCIONES INTERNAS",
                        idClient: "PERSONALIZADO",
                        interval: "NINGUNO",
                        interval_count: "0",
                        name: "PERSONALIZADO",
                        trialDays: resRestrictions.data.trialDays
                      },
                      id: "",
                      restrictions: resRestrictions.data,
                      status: {
                        val: "inactive"
                      }
                    };
                    resolve(sendRes);
                  }
                } else {
                  firebase
                    .database()
                    .ref(`users/${uid}/payment/subscription`)
                    .once(
                      "value",
                      snapshot => {
                        const res = snapshot.val();
                        // console.log(res)
                        if (res && res.id !== "-1") {
                          let bodySubscription = {
                            id_subscription: res.id
                          };
                          bodySubscription = functions.encrypt(
                            bodySubscription
                          );

                          httpAxios
                            .post(
                              vars.url + "/getSubscription",
                              bodySubscription
                            )
                            .then(async response => {
                              response.data = functions.decrypt(response.data);
                              // console.log('reposne', response)
                              if (response) {
                                if (response.data.status_plan === "active") {
                                  await firebase
                                    .database()
                                    .ref(
                                      `users/${uid}/payment/subscription/status`
                                    )
                                    .set({ val: "active" });
                                  let cont = 0;
                                  while (
                                    cont < res.restrictions.salePoints &&
                                    cont < shopsList.length
                                  ) {
                                    firebase
                                      .database()
                                      .ref(
                                        `users/${uid}/shops/${shopsList[cont].id}/status`
                                      )
                                      .set({ val: "active" });
                                    cont++;
                                  }
                                  let contCollaborator = 0;
                                  while (
                                    contCollaborator <
                                      res.restrictions.collaborators &&
                                    contCollaborator < collaboratorsList.length
                                  ) {
                                    firebase
                                      .database()
                                      .ref(
                                        `users/${uid}/collaborators/${collaboratorsList[contCollaborator].id}/status`
                                      )
                                      .set({ val: "active" });
                                    contCollaborator++;
                                  }
                                } else {
                                  await firebase
                                    .database()
                                    .ref(
                                      `users/${uid}/payment/subscription/status`
                                    )
                                    .set({ val: response.data.status_plan });
                                  for (let i = 0; i < shopsList.length; i++) {
                                    firebase
                                      .database()
                                      .ref(
                                        `users/${uid}/shops/${shopsList[i].id}/status`
                                      )
                                      .set({ val: "inactive" });
                                  }
                                  for (
                                    let i = 0;
                                    i < collaboratorsList.length;
                                    i++
                                  ) {
                                    firebase
                                      .database()
                                      .ref(
                                        `users/${uid}/collaborators/${collaboratorsList[i].id}/status`
                                      )
                                      .set({ val: "inactive" });
                                  }
                                }
                                dispatch(
                                  "users/updateVirtualShopsStatus",
                                  null,
                                  { root: true }
                                ).then(() => {
                                  // actulizado status de las virtualshops
                                });
                              }
                            });
                        } /* else if (!res) {
                        let days = vars.shopFreeDays
                        if (resRestrictions) {
                          if (resRestrictions.data !== '') {
                            days = resRestrictions.data.trialDays
                          }
                        }
                        for (let i = 0; i < shopsList.length; i++) {
                          let resolution
                          let EndTime = new Date().getTime()
                          let StartTime = shopsList[i].created
                          resolution = EndTime - StartTime
                          let resolutionTime = ((((resolution / 1000) / 60)/ 60)/24)
                          const val1 = parseFloat(resolutionTime)
                          const val2 = parseFloat(days)
                          // console.log(resolutionTime)
                          // console.log(val1)
                          // console.log(val2)
                          if (val1 > val2) {
                            // console.log('puse inactiva ', i)
                            firebase.database().ref(`users/${uid}/shops/${shopsList[i].id}/status`).set(
                              {val: 'inactive'})
                          } else {
                            firebase.database().ref(`users/${uid}/shops/${shopsList[i].id}/status`).set(
                              {val: 'active'})
                          }
                        }
                      } */
                        // console.log(res)
                        resolve(res);
                      },
                      error => {
                        // router.push(rejectPage)
                        // console.log('17', error)
                        dispatch("users/showErrorSessionExpired", null, {
                          root: true
                        });
                        reject(error);
                      }
                    );
                }
              } else {
                resolve(null);
              }
            })
            .catch(error => {
              // console.log(error)
              dispatch("users/showErrorSessionExpired", null, { root: true });
            });
        }
      });
    },
    getPlansData() {
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`plans`)
          .on(
            "value",
            snapshot => {
              const res = snapshot.val();
              let arr = Object.keys(res).map(card => {
                const data = res[card];
                data.status = "ACTIVE";
                return { id: card, data: res[card] };
              });
              arr.sort(function(a, b) {
                if (a.data.position > b.data.position) {
                  return 1;
                }
                if (a.data.position < b.data.position) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              });
              resolve(arr);
            },
            error => {
              reject(error);
            }
          );
        // httpAxios.post(vars.url + '/getAllPlans').then((response) => {
        //   response.data = functions.decrypt(response.data)
        //   resolve(response.data)
        // }).catch((error) => {
        //   router.push(rejectPage)
        //   reject(error)
        // })
      });
    },
    cancelSubscription({ state, rootState, dispatch }, dataSubscription) {
      return new Promise(async (resolve, reject) => {
        if (dataSubscription.id_subscription !== "-1") {
          const shopsList = dataSubscription.shops;
          const collaboratorsList = dataSubscription.collaborators;
          if (dataSubscription.id_subscription === "") {
            const res = {
              status: true
            };
            resolve(res);
          }

          const dataSubscriptionSet = dataSubscription;

          dataSubscription = functions.encrypt(dataSubscription);

          await httpAxios
            .post(vars.url + "/cancelSubscription", dataSubscription)
            .then(async response => {
              response.data = functions.decrypt(response.data);
              const uid = rootState.users.user.uid;
              for (let i = 0; i < shopsList.length; i++) {
                await firebase
                  .database()
                  .ref(`users/${uid}/shops/${shopsList[i].id}/status`)
                  .set({ val: "inactive" });
              }
              for (let i = 0; i < collaboratorsList.length; i++) {
                await firebase
                  .database()
                  .ref(
                    `users/${uid}/collaborators/${collaboratorsList[i].id}/status`
                  )
                  .set({ val: "inactive" });
              }
              await firebase
                .database()
                .ref(`users/${uid}/payment/subscription/status`)
                .set({ val: "canceled" })
                .then(res => {
                  // commit('SET_LOADING', false)

                  dispatch("users/updateVirtualShopsStatus", null, {
                    root: true
                  }).then(() => {
                    // actulizado status de las virtualshops
                  });
                  resolve(response.data);
                })
                .catch(err => {
                  // commit('SET_LOADING', false)
                  reject(err);
                });
              var date = new Date();
              var currentDay = date.toLocaleString();
              firebase
                .database()
                .ref(`/users/${uid}/canceled`)
                .push({
                  idSubscription: dataSubscriptionSet.id_subscription,
                  motive: dataSubscriptionSet.txtMotive,
                  date: currentDay
                })
                .then(res => {
                  // commit('SET_LOADING', false)
                 // console.log("canceled", response.data);
                  resolve(response.data);
                })
                .catch(err => {
                  // commit('SET_LOADING', false)
                  // router.push(rejectPage)
                  reject(err);
                });
            })
            .catch(error => {
              // router.push(rejectPage)
              reject(error);
            });
        } else {
          // es el plan reactivate y no se cancela porque no existe en epayco
          const res = {
            status: true
          };
          resolve(res);
        }
      });
    },
    paySubscription({ state, rootState }, dataSubscription) {
      return new Promise((resolve, reject) => {
        const shopsList = dataSubscription.shops;
        const collaboratorsList = dataSubscription.collaborators;
        const uid = rootState.users.user.uid;
        firebase
          .database()
          .ref(`users/${uid}/payment`)
          .once(
            "value",
            snapshot => {
              let dataPayment = snapshot.val();
              let dataSubscriptionBody = {
                id_plan: dataSubscription.id_plan,
                customer: dataPayment.customer.data.customerId,
                token_card: dataPayment.token.id,
                doc_type: dataSubscription.doc_type,
                doc_number: dataSubscription.doc_number,
                ip: dataSubscription.ip
              };
              const restrictions = dataPayment.subscription.restrictions;
              dataSubscriptionBody = functions.encrypt(dataSubscriptionBody);
              httpAxios
                .post(vars.url + "/paySubscription", dataSubscriptionBody)
                .then(async response => {
                  response.data = functions.decrypt(response.data);
                  // console.log('response epayco pay', response.data)
                  if (response.data.success) {
                    // se espera a la ejecucion de la segunda confirmacion del pago a epayco(callback)
                    await firebase
                      .database()
                      .ref(`users/${uid}/profile/`)
                      .update({ pendingPay: true });
                    /* if (response.data.subscription.status === 'pending' || response.data.subscription.status === 'active') {
                  } */
                    if (response.data.subscription.status === "active") {
                      // suscripcion exitosa se activan colaboradores y tiendas
                      let cont = 0;
                      while (
                        cont < restrictions.salePoints &&
                        cont < shopsList.length
                      ) {
                        firebase
                          .database()
                          .ref(
                            `users/${uid}/shops/${shopsList[cont].id}/status`
                          )
                          .set({ val: "active" });
                        cont++;
                      }
                      let contCollaborator = 0;
                      while (
                        contCollaborator < restrictions.collaborators &&
                        contCollaborator < collaboratorsList.length
                      ) {
                        firebase
                          .database()
                          .ref(
                            `users/${uid}/collaborators/${collaboratorsList[contCollaborator].id}/status`
                          )
                          .set({ val: "active" });
                        contCollaborator++;
                      }
                    }
                    // se actualiza el status de la suscripcion en bd
                    firebase
                      .database()
                      .ref(`users/${uid}/payment/subscription/status`)
                      .set({ val: response.data.subscription.status })
                      .then(res => {
                        // commit('SET_LOADING', false)ge
                        resolve(response.data);
                      })
                      .catch(err => {
                        // commit('SET_LOADING', false)
                        // router.push(rejectPage)
                        reject(err);
                      });
                  } else {
                    firebase
                      .database()
                      .ref(`users/${uid}/payment/subscription/status`)
                      .set({ val: "inactive" })
                      .then(res => {
                        // commit('SET_LOADING', false)
                        resolve(response.data);
                      })
                      .catch(err => {
                        // commit('SET_LOADING', false)
                        // router.push(rejectPage)
                        reject(err);
                      });
                  }
                  resolve(response.data);
                })
                .catch(error => {
                  // router.push(rejectPage)
                  reject(error);
                });
            },
            error => {
              // router.push(rejectPage)
              reject(error);
            }
          );
      });
    },
    getSubscriptionsData({ rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        const uid = rootState.users.user.uid;
        firebase
          .database()
          .ref(`users/${uid}/payment/customer/data`)
          .once(
            "value",
            snapshot => {
              const dataCustomer = snapshot.val();
              if (dataCustomer) {
                const id_customer = dataCustomer.customerId;
                //console.log("IDCUS =", id_customer);
                httpAxios
                  .post(vars.url + "/getAllSubscriptions")
                  .then(response => {
                    response.data = functions.decrypt(response.data);
                    //console.log(response.data);
                    const arrData = response.data;
                    // let arrDatRes = arrData.filter(sub => sub.idCustomer == id_customer && sub.status != 'canceled')
                    let arrDatRes = arrData.filter(
                      sub => sub.idCustomer == id_customer
                    );
                    const dataResponse = {
                      status: arrDatRes.status,
                      array: arrDatRes
                    };
                    resolve(dataResponse);
                  })
                  .catch(error => {
                    reject(error);
                  });
              } else {
                resolve(null);
              }
            },
            error => {
              dispatch("users/showErrorSessionExpired", null, { root: true });
              reject(error);
            }
          );
      });
    },
    getCustomerData({ state, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        const uid = rootState.users.user.uid;
        firebase
          .database()
          .ref(`users/${uid}/payment/customer/data`)
          .once(
            "value",
            snapshot => {
              const dataCustomer = snapshot.val();
              if (dataCustomer) {
                let bodyCustomer = {
                  id_customer: dataCustomer.customerId
                };

                bodyCustomer = functions.encrypt(bodyCustomer);

                httpAxios
                  .post(vars.url + "/getCustomer", bodyCustomer)
                  .then(response => {
                    response.data = functions.decrypt(response.data);
                    if (!response.data.data.phone) {
                      let address = "";
                      let city = "";
                      if (rootState.users.profile.city) {
                        address =
                          rootState.users.profile.city +
                          " " +
                          rootState.users.profile.address; // + ' ' + rootState.users.profile.street
                        city = rootState.users.profile.city;
                      } else {
                        address = "BARRANQUILLA";
                        city = "BARRANQUILLA";
                      }
                      let bodyUpdateCustomer = {
                        id_customer: response.data.data.id_customer,
                        update_customer_info: {
                          phone: rootState.users.profile.phone
                        }
                      };
                      httpAxios
                        .post(vars.url + "/updateCustomer", bodyUpdateCustomer)
                        .then(response => {
                          if (response) {
                            // console.log(response)
                          }
                        })
                        .catch(error => {
                          // console.log(error)
                        });
                    }
                    firebase
                      .database()
                      .ref(`users/${uid}/cards`)
                      .once(
                        "value",
                        snapshot => {
                          const res = snapshot.val();
                          let arr = Object.keys(res).map(card => {
                            return { id: card, data: res[card] };
                          });
                          const dataResponse = {
                            dataCustomer: dataCustomer,
                            responseCustomer: response.data,
                            cardList: arr
                          };
                          resolve(dataResponse);
                        },
                        error => {
                          reject(error);
                        }
                      );
                  })
                  .catch(error => {
                    reject(error);
                  });
              } else {
                resolve(null);
              }
            },
            error => {
              // router.push(rejectPage)
              dispatch("users/showErrorSessionExpired", null, { root: true });
              reject(error);
            }
          );
      });
    },
    tokenization({ state, rootState }, data) {
      return new Promise((resolve, reject) => {
        data.dataCard = functions.encrypt(data.dataCard);

        httpAxios
          .post(vars.url + "/createToken", data.dataCard)
          .then(response => {
            response.data = functions.decrypt(response.data);
            if (response.data.status) {
              const uid = rootState.users.user.uid;
              firebase
                .database()
                .ref(`users/${uid}/payment`)
                .update({
                  card: response.data.card,
                  token: response.data.data,
                  person: data.dataUser
                })
                .then(res => {
                  // commit('SET_LOADING', false)
                  firebase
                    .database()
                    .ref(`users/${uid}/cards`)
                    .push({
                      card: response.data.card,
                      token: response.data.data,
                      person: data.dataUser
                    });
                  resolve(response);
                })
                .catch(err => {
                  // commit('SET_LOADING', false)
                  // router.push(rejectPage)
                  reject(err);
                });
            } else {
              resolve(response.data.status);
            }
          })
          .catch(error => {
            // router.push(rejectPage)
            reject(error);
          });
      });
    },
    cancelToken({ state, rootState }, dataCancel) {
      return new Promise((resolve, reject) => {
        const uid = rootState.users.user.uid;
        firebase
          .database()
          .ref(`users/${uid}/payment`)
          .once("value", snapshot => {
            if (snapshot.val()) {
              const resfire = snapshot.val();
              const id_customer = resfire.customer.data.customerId;
              const dataCancelSet = dataCancel;
              dataCancel["customer_id"] = id_customer;

              dataCancel = functions.encrypt(dataCancel);

              httpAxios
                .post(vars.url + "/cancelToken", dataCancel)
                .then(response => {
                  response.data = functions.decrypt(response.data);
                  if (response.data.status) {
                    if (dataCancelSet.mask == resfire.card.mask) {
                      firebase
                        .database()
                        .ref(`users/${uid}/payment/card`)
                        .remove();
                    }
                    firebase
                      .database()
                      .ref(`users/${uid}/cards/${dataCancelSet.id_card}`)
                      .remove();
                    resolve(response.data);
                  } else {
                    resolve(response.data.status);
                  }
                })
                .catch(error => {
                  // router.push(rejectPage)
                  reject(error);
                });
            } else {
              resolve(null);
            }
          });
      });
    },
    createCustomer({ state, rootState }, dataUser) {
      return new Promise((resolve, reject) => {
        const uid = rootState.users.user.uid;
        firebase
          .database()
          .ref(`users/${uid}/payment`)
          .once(
            "value",
            snapshot => {
              if (snapshot.val()) {
                const response = snapshot.val();
                const id_token = response.token.id;
                let customer = {
                  token_card: id_token,
                  name: rootState.users.profile.name,
                  last_name: rootState.users.profile.last_name,
                  email: dataUser.userEmail,
                  address: dataUser.address,
                  phone: dataUser.phone,
                  city: dataUser.city,
                  cell_phone: dataUser.phone,
                  default: true
                };

                customer = functions.encrypt(customer);

                httpAxios
                  .post(vars.url + "/createCustomer", customer)
                  .then(response => {
                    response.data = functions.decrypt(response.data);
                    if (response.data.status) {
                      const uid = rootState.users.user.uid;
                      firebase
                        .database()
                        .ref(`users/${uid}/payment/customer`)
                        .set({
                          data: response.data.data
                        })
                        .then(res => {
                          // commit('SET_LOADING', false)
                          resolve(response);
                        })
                        .catch(err => {
                          // commit
                          // router.push(rejectPage)
                          reject(err);
                        });
                    } else {
                      resolve(response.data.status);
                    }
                  })
                  .catch(error => {
                    // router.push(rejectPage)
                    reject(error);
                  });
              }
            },
            error => {
              // router.push(rejectPage)
              reject(error);
            }
          );
      });
    },
    createSubscription({ state, rootState }, dataSubscription) {
      const shopsList = dataSubscription.shops;
      const collaboratorsList = dataSubscription.collaborators;
      const uid = rootState.users.user.uid;
      return new Promise((resolve, reject) => {
        if (dataSubscription.id_plan === "Plan_Reactivate") {
          const dataPlan = {
            amount: 0,
            createdAt: moment().format("YYYY-MM-DD"),
            currency: "cop",
            description:
              "Plan gratuito mensual con una tienda virtual, un punto de venta y limite de 100 ventas",
            idClient: "Plan_Reactivate",
            interval: "month",
            name: "Plan Reactivate"
          };
          firebase
            .database()
            .ref(`users/${uid}/payment/subscription`)
            .set({
              data: dataPlan,
              id: "-1",
              status: {
                val: "active"
              },
              restrictions: dataSubscription.restrictions
            });
          let cont = 0;
          while (
            cont < dataSubscription.restrictions.salePoints &&
            cont < shopsList.length
          ) {
            // console.log(`users/${uid}/shops/${shopsList[cont].id}/status`, dataSubscription)
            // console.log(shopsList.length)
            firebase
              .database()
              .ref(`users/${uid}/shops/${shopsList[cont].id}/status`)
              .set({ val: "active" });
            cont++;
          }
          for (let i = 0; i < collaboratorsList.length; i++) {
            firebase
              .database()
              .ref(
                `users/${uid}/collaborators/${collaboratorsList[i].id}/status`
              )
              .set({ val: "inactive" });
          }
          resolve();
        } else {
          firebase
            .database()
            .ref(`users/${uid}/payment`)
            .once(
              "value",
              snapshot => {
                if (snapshot.val()) {
                  const response = snapshot.val();
                  const id_token = response.token.id;
                  const id_customer = response.customer.data.customerId;

                  let constCcType = "CC";
                  let constCcNumber = "9999999999";
                  if (
                    response.person.doc_type &&
                    response.person.doc_type.value
                  ) {
                    constCcType = response.person.doc_type.value;
                  }
                  // console.log(response)

                  if (response.person.doc_type) {
                    constCcNumber = response.person.doc_number;
                  }

                  let dataSubscriptionSend = {
                    id_plan: dataSubscription.id_plan,
                    customer: id_customer,
                    token_card: id_token,
                    doc_type: constCcType,
                    doc_number: constCcNumber
                  };
                  // console.log(dataSubscriptionSend)
                  dataSubscriptionSend = functions.encrypt(
                    dataSubscriptionSend
                  );
                  // console.log('1')
                  httpAxios
                    .post(
                      vars.url + "/createSubscription",
                      dataSubscriptionSend
                    )
                    .then(response => {
                      response.data = functions.decrypt(response.data);
                      // console.log('2', response.data)
                      if (response.data.success) {
                        response.data.data.createdAt = moment().format(
                          "YYYY-MM-DD"
                        );
                        firebase
                          .database()
                          .ref(`users/${uid}/payment/subscription`)
                          .set({
                            data: response.data.data,
                            id: response.data.id,
                            status: {
                              val: "inactive"
                            },
                            restrictions: dataSubscription.restrictions
                          })
                          .then(res => {
                            // commit('SET_LOADING', false)
                            resolve(response);
                          })
                          .catch(err => {
                            // commit('SET_LOADING', false)
                            // router.push(rejectPage)
                            reject(err);
                          });
                        let cont = 0;
                        while (
                          cont < dataSubscription.restrictions.salePoints &&
                          cont < shopsList.length
                        ) {
                          firebase
                            .database()
                            .ref(
                              `users/${uid}/shops/${shopsList[cont].id}/status`
                            )
                            .set({ val: "active" });
                          cont++;
                        }
                        let contCollaborator = 0;
                        while (
                          contCollaborator <
                            dataSubscription.restrictions.collaborators &&
                          contCollaborator < collaboratorsList.length
                        ) {
                          firebase
                            .database()
                            .ref(
                              `users/${uid}/collaborators/${collaboratorsList[contCollaborator].id}/status`
                            )
                            .set({ val: "active" });
                          contCollaborator++;
                        }
                      } else {
                        // console.log('3')
                        resolve(response.data.success);
                      }
                    })
                    .catch(error => {
                      // router.push(rejectPage)
                      reject(error);
                    });
                }
              },
              error => {
                // router.push(rejectPage)
                reject(error);
              }
            );
        }
      });
    },
    getAllPlansApayco() {
      return new Promise((resolve, reject) => {
        httpAxios
          .post(vars.url + "/getAllPlans")
          .then(response => {
            response.data = functions.decrypt(response.data);
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getChangeRestrictions({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`users/${rootState.users.user.uid}/profile/restrictions`)
          .on(
            "value",
            snapshot => {
              const res = snapshot.val();
              commit("SET_RESTRICTIONS", res);
              resolve(res);
            },
            error => {
              commit("SET_RESTRICTIONS", null);
              reject(error);
            }
          );
      });
    },
    getCurrencies({ commit }) {
      let currencies = {};
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref("currency/")
          .once(
            "value",
            snapshot => {
              currencies = snapshot.val();
              commit("SET_CURRENCIES", currencies);
              resolve(currencies);
            },
            error => {
              reject(error);
            }
          );
      });
    }
  },
  getters: {
    getCurrencies(state) {
      return state.currencies;
    }
  }
};
